import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      justifyContent: 'start',
      gap: theme.spacing(2),
      padding: theme.spacing(2),
      borderRadius: theme.shape.borderRadius,
      border: theme.shape.borderGray60,

      '&:hover': {
        backgroundColor: COLORS.gray.gray90,
      },
    },
    icon: {},
    texts: {
      display: 'flex',
      flexFlow: 'column nowrap',
      alignItems: 'start',
      gap: theme.spacing(0.5),
    },
    title: {
      color: COLORS.gray.black,
    },
    description: {
      color: COLORS.gray.gray40,
    },
  }),
  { name: 'ProjectTypeButton' }
);
